import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';

@Injectable({
  providedIn: 'root'
})
export class AccessDataBackendServer extends BaseBackend {
  getAccessDataList(builder): Observable<any> {
    return this.get('/access-data', { params: builder });
  }

  getChartAccessDataList(builder): Observable<any> {
    return this.get('/access-data/chart', { params: builder });
  }

  deleteAccessData(entryId): Observable<any> {
    return this.delete(`/access-data/${ entryId }`);
  }

  deleteAllAccessData(): Observable<any> {
    return this.delete('/access-data/delete/all');
  }
}
